module.exports = __webpack_public_path__ + "img/14-3.21dee3b1.png";